import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import './Auth.css';

const Register = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    role: 'student',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const { register, user } = useAuth();
  const navigate = useNavigate();

  const handleGoogleSignup = () => {
    localStorage.setItem('intended_role', formData.role);
    window.location.href = '/api/auth/google';
  };

  React.useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await register(formData);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h1>{t('auth.registerTitle')}</h1>

        <button type="button" onClick={handleGoogleSignup} className="google-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          {t('auth.signupGoogle')}
        </button>

        <div className="divider"><span>{t('auth.orDivider')}</span></div>

        <form onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label htmlFor="reg-first_name">{t('auth.firstName')}</label>
            <input
              id="reg-first_name"
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              required
              autoComplete="given-name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="reg-last_name">{t('auth.lastName')}</label>
            <input
              id="reg-last_name"
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              required
              autoComplete="family-name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="reg-email">{t('auth.email')}</label>
            <input
              id="reg-email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="reg-password">{t('auth.password')}</label>
            <input
              id="reg-password"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              minLength="6"
              autoComplete="new-password"
              aria-describedby="reg-password-hint"
            />
            <span id="reg-password-hint" className="field-hint">{t('auth.passwordHint')}</span>
          </div>

          <div className="form-group">
            <label htmlFor="reg-role">{t('auth.role')}</label>
            <select id="reg-role" name="role" value={formData.role} onChange={handleChange}>
              <option value="student">{t('auth.roleStudent')}</option>
              <option value="instructor">{t('auth.roleInstructor')}</option>
            </select>
          </div>

          {error && <div className="error" role="alert" aria-live="assertive">{error}</div>}

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? t('auth.registering') : t('auth.registerBtn')}
          </button>

          <p className="auth-link">
            {t('auth.hasAccount')} <Link to="/login">{t('auth.signInLink')}</Link>
          </p>
          <p className="auth-link" style={{ fontSize: '12px', color: '#9ca3af' }}>
            {t('auth.agreeRegister')} <Link to="/privacy">{t('gdpr.learnMore')}</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Register;
